import React from "react";
import {t} from "i18next";
import {Tooltip} from "../sublayouts/components/bootstrap/tooltip";
import {formatStrDateTime, isValidDateString} from "./date";

export function getBoolSymbolWithTooltip(
  val,
  customTooltipTrue,
  customTooltipFalse,
  customParentStyle,
  customTrueSymbol = <i className="fas fa-check-circle" />,
  customFalseSymbol = <i className="fas fa-ban" />
) {
  const spanCn = val ? "text-dark-grey" : "text-light-grey";

  let message = val
    ? customTooltipTrue || t("general.alert.true")
    : customTooltipFalse || t("general.alert.false");

  return (
    <div style={customParentStyle || {width: "max-content"}}>
      <Tooltip message={message} placement="bottom">
        <span className={"isactive " + spanCn}>
          {val ? customTrueSymbol : customFalseSymbol}
        </span>
      </Tooltip>
    </div>
  );
}

export function convertToTitleCase(str) {
  if (!str) {
    return "";
  }
  return str.toLowerCase().replace(/\b\w/g, (s) => s.toUpperCase());
}

export function cleanTextElement(
  val: unknown,
  callbackFunc?: (data: unknown) => unknown,
  formatString?: string,
) {
  if (isValidDateString(val)) {
    return formatStrDateTime(String(val), formatString);
  }

  return cleanValue(val, callbackFunc);
}

function cleanValue(data: unknown, callbackFunc?: (data: unknown) => unknown) {
  if (
    (typeof data === "string" && data.trim() !== "") ||
    (Array.isArray(data) && data.length > 0) ||
    (typeof data === "object" && data !== null && Object.keys(data).length > 0)
  ) {
    return callbackFunc ? callbackFunc(data) : data;
  }

  return t("general.alert.notAvailable");
}
